import React from 'react';

import { useParseContract } from '@consumer-frontend/nc-api';
import { ProductTypeDisplayT } from '@consumer-frontend/nc-utils';

import '@consumer-bootstrap/brands/netcredit/contract/contract.scss';

export type NcContractHTMLPropsT = {
  body: string;
  brandSignature: string;
  customerSignature: string;
  productTypeDisplay: ProductTypeDisplayT;
};
export type NcContractHTMLT = React.FC<NcContractHTMLPropsT>;

export const NcContractHTML: NcContractHTMLT = ({
  body,
  brandSignature,
  customerSignature,
  productTypeDisplay,
}) => {
  const safeHTML = useParseContract(body, productTypeDisplay);
  let showCustomerSignature = true;

  if (safeHTML.includes('customer-signature')) {
    showCustomerSignature = false;
  }

  return (
    <div id="contract">
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: safeHTML }} />
      {showCustomerSignature && (
        <pre id="customer-signature">
          {customerSignature}
        </pre>
      )}
      {brandSignature && (
        <pre id="brand-signature">
          {brandSignature}
        </pre>
      )}
    </div>
  );
};
